/**
 * Builds ticket-printer groups for Product Detail (Individual Settings) from workspace `data[]`,
 * matching the legacy shape previously derived from `dsokSettings.customer.workspaces`.
 *
 * @param {object[]|null|undefined} workspacesArray — `normalizeWorkspacesForUi(doc).data`
 * @returns {{ workspaceKey: string, workspaceName: string, printers: object[] }[]}
 */
export function buildTicketPrintersGroupedFromWorkspacesData(workspacesArray) {
  if (!Array.isArray(workspacesArray) || workspacesArray.length === 0) {
    return [];
  }

  return workspacesArray
    .map((workspace, index) => {
      if (!workspace || typeof workspace !== "object") {
        return null;
      }
      const workspaceUuid = workspace.uuid || String(index + 1);
      const workspaceName =
        (typeof workspace.name === "string" && workspace.name.trim()) ||
        workspaceUuid;

      const devices = Array.isArray(workspace.devices)
        ? workspace.devices
        : [];

      const printers = devices
        .filter(
          (d) =>
            d &&
            typeof d === "object" &&
            (d.type === "ticket" || d.type === "accessTicket"),
        )
        .map((d, i) => {
          const uuid = (d.uuid && String(d.uuid).trim()) || "";
          const fallbackKey = `${workspaceUuid}-${i + 1}`;
          const id = uuid || fallbackKey;
          return {
            id,
            uuid,
            name:
              (typeof d.name === "string" && d.name.trim()) || fallbackKey,
            type: d.type || "",
            ipAddress:
              (typeof d.ipAddress === "string" && d.ipAddress.trim()) || "",
          };
        });

      if (!printers.length) {
        return null;
      }

      return {
        workspaceKey: workspaceUuid,
        workspaceName,
        printers,
      };
    })
    .filter(Boolean);
}
